module.exports = __webpack_public_path__ + "img/phone-case.6f0f2027.svg";